import type { ApiPlaceOrderType } from '../../../apps/api-hono/src/routes/api_place_order/_router'
import { hc } from 'hono/client'
import { getEnvVariable } from '@lib/utils/getEnvVariable';
import { getClientRequestOptions } from './getClientRequestOptions';

const client = hc<ApiPlaceOrderType>('')
type Client = typeof client

export const createPlaceOrderApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiPlaceOrderType>(...args)
}

export const placeOrderApiClient = createPlaceOrderApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/place_order/`,
    getClientRequestOptions()
)



